const wordExceptionsES = ['a', 'de', 'con'];
const wordExceptionsEN = ['of'];
const wordExceptionsUppercaseEN = ['cv']; // Written lowercase here
const wordExceptionsUppercaseES = ['cv']; // Written lowercase here

export const WORDEXCEPTIONS = [...wordExceptionsEN, ...wordExceptionsES];
export const WORDEXCEPTIONSUPPERCASE = [...wordExceptionsUppercaseEN, ...wordExceptionsUppercaseES];
